export type CropRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type ImageDimensions = {
  width: number;
  height: number;
};

export const normalizeRotationDegrees = (rotationDegrees: number) =>
  ((rotationDegrees % 360) + 360) % 360;

export const getRotatedImageDimensions = (
  sourceDimensions: ImageDimensions,
  rotationDegrees: number,
): ImageDimensions => {
  const normalizedRotation = normalizeRotationDegrees(rotationDegrees);
  const isSideways = normalizedRotation === 90 || normalizedRotation === 270;

  return {
    width: isSideways ? sourceDimensions.height : sourceDimensions.width,
    height: isSideways ? sourceDimensions.width : sourceDimensions.height,
  };
};

export const sourceCropToRotatedCrop = (
  crop: CropRect,
  sourceDimensions: ImageDimensions,
  rotationDegrees: number,
): CropRect => {
  const normalizedRotation = normalizeRotationDegrees(rotationDegrees);
  const { x, y, width, height } = crop;

  switch (normalizedRotation) {
    case 90:
      return {
        x: sourceDimensions.height - (y + height),
        y: x,
        width: height,
        height: width,
      };
    case 180:
      return {
        x: sourceDimensions.width - (x + width),
        y: sourceDimensions.height - (y + height),
        width,
        height,
      };
    case 270:
      return {
        x: y,
        y: sourceDimensions.width - (x + width),
        width: height,
        height: width,
      };
    default:
      return crop;
  }
};

export const rotatedCropToSourceCrop = (
  crop: CropRect,
  sourceDimensions: ImageDimensions,
  rotationDegrees: number,
): CropRect => {
  const normalizedRotation = normalizeRotationDegrees(rotationDegrees);
  const { x, y, width, height } = crop;

  switch (normalizedRotation) {
    case 90:
      return {
        x: y,
        y: sourceDimensions.height - (x + width),
        width: height,
        height: width,
      };
    case 180:
      return {
        x: sourceDimensions.width - (x + width),
        y: sourceDimensions.height - (y + height),
        width,
        height,
      };
    case 270:
      return {
        x: sourceDimensions.width - (y + height),
        y: x,
        width: height,
        height: width,
      };
    default:
      return crop;
  }
};
